import type React from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../components/skeleton/Card'
import TextInput from '../../components/FormElements/TextInput'
import { Button } from '../../components/ui/Button'

interface ForgotPasswordFormData {
  email: string
}

export const ForgotPasswordCard: React.FC = () => {
  const methods = useForm<ForgotPasswordFormData>()

  const onSubmit = (data: ForgotPasswordFormData) => {
    console.log('Forgot password request for:', data.email)
    // Here you would typically handle the password reset request
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 h-screen bg-foreground/50 dark:bg-slate-700">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-center">
            Forgot Password
          </CardTitle>
          <CardDescription className="text-center">
            Enter your email address and we'll send you a link to reset your password.
          </CardDescription>
        </CardHeader>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <CardContent>
              <TextInput
                name="email"
                label="Email"
                type="email"
                rules={{
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                }}
              />
            </CardContent>
            <CardFooter>
              <div className="flex flex-col gap-2 w-full">
                <a
                  href="login"
                  className="mr-auto inline-block text-sm underline-offset-4 hover:underline">
                  Back to login
                </a>
                <Button type="submit" className="w-full">
                  Reset Password
                </Button>
              </div>
            </CardFooter>
          </form>
        </FormProvider>
      </Card>
    </div>
  )
}
